"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sitesSync = void 0;
const store_1 = require("../../../../sites/modules/sites-detail/store");
const rows = require('../../../../../../../data/sheets/pharmacies.json');
const zipcodeToTimezone = require('zipcode-to-timezone');
exports.sitesSync = () => Promise.all(Object.values(rows.pharmacies).map(async (row, i) => {
    const skipRows = [1]; // Hardcoded rows to skip.
    const site = {
        address: '',
        city: '',
        deaLicense: '0',
        fax: '',
        id: '',
        inventories: '',
        live: true,
        name: '',
        displayName: '',
        ncpdpId: '',
        notes: '',
        npiNumber: '',
        picProvider: '',
        picProviderId: 0,
        phone: '',
        state: '',
        zip: '',
        timezone: '',
    };
    if (row.nameShort && skipRows.indexOf(i + 1) === -1) {
        const address = row.address.split(' ');
        const street = address.slice(0, address.length - 3).join(' ');
        site.zip = address[address.length - 1];
        site.state = address[address.length - 2];
        site.city = address[address.length - 3].replace(',', '');
        site.name = row.nameLong;
        site.displayName = row.nameShort;
        site.address = street;
        site.npiNumber = row.npi;
        site.phone = row.phoneNumber;
        site.ncpdpId = row.ncpdp;
        site.timezone = zipcodeToTimezone.lookup(site.zip);
        return store_1.sitesDetailStore.createSite(site);
    }
    return null;
}));



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sync/modules/google-sync/modules/google-sites.ts
// module id = 4144
// module chunks = 0